export enum PAYMENT_STATUS {
  NO_PAYMENT = 'no_payment',
  PAID = 'paid',
  TRIALING = 'trialing',
  IN_COMPLETE = 'incomplete',
  IN_COMPLETE_EXPIRED = 'incomplete_expired',
  PAST_DUE = 'past_due',
  CANCELED = 'canceled',
}
export const ENTER_KEY = 'Enter';
export const DEFAULT_VENDOR_LOGO = '/images/default-vendor.png';
export enum PRODUCT_TAB_KEY {
  Overview,
  Features,
  Alternatives,
  Pricing,
  Manufacturer,
}
export const VERIFIED_VENDOR_MESSAGE = 'This vendor is verified by askiot';
export enum SUBSCRIPTION_PLANS {
  FREE = 'free',
  KICKSTART = 'kickstart',
  GROWTH = 'growth',
  PRO = 'pro',
  ENTERPRISE = 'enterprise',
  // Legacy
  PROFESSIONAL = 'professional',
  BUSINESS = 'business',
}

export const REQUEST_METHOD = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  PATCH: 'PATCH',
  DELETE: 'DELETE',
};

export const OTP_LENGTH = 6;
export const MAX_LEAD_EMAILS = 3;
export enum USER_ROLE {
  ADMIN = 'admin',
  USER = 'user',
}

export const LIMIT_RESTRICT_LIST_LENGTH = 5;

export enum ACTIONS_KEY {
  EDIT,
  DELETE,
  DUPLICATE,
}
